document.addEventListener('DOMContentLoaded', function () {
  // Seleciona o input, o botão e a área de mensagem do cupom
  const inputCoupon = document.querySelector('#CartDiscountcode');
  const applyButton = document.querySelector('.apply-btn');
  const couponMessage = document.querySelector('#coupon-message'); 
  if (!inputCoupon || !applyButton) return;

  // Ao clicar, salva o cupom no localStorage e redireciona para aplicar
  applyButton.addEventListener('click', function () {
    const couponCode = inputCoupon.value.trim();
    if (!couponCode) {
      couponMessage.style.color = 'red';
      couponMessage.innerText = 'Por favor, insira um cupom.';
      return;
    }
    localStorage.setItem('desired_coupon', couponCode);
    window.location.href = `/discount/${encodeURIComponent(couponCode)}?redirect=/cart`;
  });

  // Ao recarregar a página do carrinho, verifica se um cupom foi desejado
  const couponWeWanted = localStorage.getItem('desired_coupon');
  if (couponWeWanted) {
    if (!inputCoupon.value) {
      inputCoupon.value = couponWeWanted;
    }
    // Aguarda 1000ms para o Shopify atualizar os dados do carrinho
    setTimeout(function () {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          console.log("Cart Data:", cartData);
          // Calcula o desconto aplicado: diferença entre original_total_price e total_price
          const discountValue = cartData.original_total_price - cartData.total_price;
          console.log("Discount Value:", discountValue);
          // Se existir discount_applications ou o desconto for maior que zero, consideramos que o cupom foi aplicado
          if ((cartData.discount_applications && cartData.discount_applications.length > 0) || discountValue > 0) {
            couponMessage.style.color = 'green';
            couponMessage.innerText = 'Cupom aplicado com sucesso!';
          } else {
            couponMessage.style.color = 'red';
            couponMessage.innerText = 'Cupom inválido ou não se aplica a estes itens.';
          }
          localStorage.removeItem('desired_coupon');
        })
        .catch(error => {
          console.error("Erro ao verificar o cupom:", error);
          couponMessage.style.color = 'red';
          couponMessage.innerText = 'Erro ao verificar o cupom.';
          localStorage.removeItem('desired_coupon');
        });
    }, 1000);
  }
});
